// src/pages/AccessibilityPage.js
import React from 'react';
import { Monitor, MousePointer, Keyboard, Eye } from 'lucide-react';

const AccessibilityPage = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold text-center mb-8">הצהרת נגישות</h1>
      
      <div className="bg-white rounded-lg shadow-lg p-6 space-y-8">
        {/* הקדמה */}
        <section>
          <p className="text-gray-600">
            משרד עורכי דין אראל וחן מאמין ופועל למען שוויון הזדמנויות ונגישות מלאה לכל אדם. 
            אנו מחויבים להנגיש את השירותים המשפטיים והאתר שלנו לכלל האוכלוסייה, כולל אנשים עם מוגבלויות.
          </p>
        </section>

        {/* רמת הנגישות */}
        <section className="space-y-4">
          <div className="flex items-start gap-4">
            <Monitor className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
            <div>
              <h2 className="text-xl font-bold mb-2">רמת הנגישות באתר</h2>
              <p className="text-gray-600">
                אתר זה עומד בדרישות תקנות שוויון זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות), 
                תשע"ג 2013 ותקן ישראלי ת"י 5568 לנגישות תכנים באינטרנט ברמה AA.
              </p>
            </div>
          </div>
        </section>

        {/* התאמות הנגישות */}
        <section className="space-y-6">
          <h2 className="text-xl font-bold">התאמות הנגישות באתר כוללות:</h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="flex items-start gap-3">
              <MousePointer className="w-5 h-5 text-blue-600 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-bold mb-1">תפעול מלא במקלדת</h3>
                <p className="text-gray-600 text-sm">
                  ניתן לגלוש באתר באמצעות המקלדת בלבד וללא שימוש בעכבר
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <Eye className="w-5 h-5 text-blue-600 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-bold mb-1">ניגודיות צבעים</h3>
                <p className="text-gray-600 text-sm">
                  האתר מציג טקסט בצבעים נגישים עם ניגודיות גבוהה
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <Keyboard className="w-5 h-5 text-blue-600 flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-bold mb-1">תיאור תמונות</h3>
                <p className="text-gray-600 text-sm">
                  כל התמונות באתר מכילות תיאור טקסטואלי חלופי
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* אמצעי נגישות */}
        <section className="space-y-4">
          <h2 className="text-xl font-bold mb-4">דרכים נוספות לקבלת השירות</h2>
          <ul className="space-y-2 text-gray-600">
            <li>• ניתן לפנות אלינו טלפונית לקבלת שירות</li>
            <li>• קיימת אפשרות לתיאום פגישה פרונטלית במשרדנו</li>
            <li>• במידת הצורך, נשמח להגיע אליכם</li>
          </ul>
        </section>

        {/* יצירת קשר לנושאי נגישות */}
        <section className="mt-8 pt-8 border-t">
          <h2 className="text-xl font-bold mb-4">פניות בנושא נגישות</h2>
          <p className="text-gray-600">
            נתקלתם בבעיית נגישות באתר? נשמח לקבל משוב ולסייע.
            ניתן לפנות לרכז הנגישות שלנו חן באמצעות:
          </p>
          <ul className="mt-4 space-y-2 text-gray-600">
            <li>• טלפון:0532788686</li>
            <li>• דוא"ל: office@mdc-lawfirm.com</li>
          </ul>
        </section>
{/* נגישות המשרד */}
<section className="mt-8 pt-8 border-t">
  <h2 className="text-xl font-bold mb-4">נגישות המשרד הפיזי</h2>
  <div className="bg-gray-50 rounded-lg p-6">
    <ul className="space-y-3">
      <li className="flex items-center gap-2">
        <span className="text-blue-600">•</span>
        <span className="font-medium">כתובת:</span> 
        <span className="text-gray-600">ילדי טהרן 8, ראשון לציון</span>
      </li>
      <li className="flex items-center gap-2">
        <span className="text-blue-600">•</span>
        <span className="font-medium">חניית נכים:</span>
        <span className="text-gray-600">יש</span>
      </li>
      <li className="flex items-center gap-2">
        <span className="text-blue-600">•</span>
        <span className="font-medium">דרכי גישה לבניין:</span>
        <span className="text-gray-600">יש גישה לכיסא גלגלים</span>
      </li>
      <li className="flex items-center gap-2">
        <span className="text-blue-600">•</span>
        <span className="font-medium">שירותי נכים:</span>
        <span className="text-gray-600">יש</span>
      </li>
      <li className="flex items-center gap-2">
        <span className="text-blue-600">•</span>
        <span className="font-medium">מעברים רחבים:</span>
        <span className="text-gray-600">יש</span>
      </li>
      <li className="flex items-center gap-2">
        <span className="text-blue-600">•</span>
        <span className="font-medium">שילוט הכוונה:</span>
        <span className="text-gray-600">יש</span>
      </li>
      <li className="flex items-center gap-2">
        <span className="text-blue-600">•</span>
        <span className="font-medium">מעלית:</span>
        <span className="text-gray-600">יש</span>
      </li>
    </ul>
  </div>
</section>
        {/* עדכון אחרון */}
        <div className="text-sm text-gray-500 mt-8">
          הצהרת הנגישות עודכנה לאחרונה בתאריך: ינואר 2024
        </div>
      </div>
    </div>
  );
};

export default AccessibilityPage;